import React from "react";
import { Helmet } from "react-helmet-async";
import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/hero3.png";
import "./privacy-policy.css";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Customer Supports 24x7</title>
        <meta
          name="description"
          content="Read the Customer Supports 24x7 privacy policy for appliance repair service enquiries and bookings."
        />
        <link rel="canonical" href="https://customersupports24x7.in/privacy-policy" />
      </Helmet>

      <InnerBanner title="Privacy Policy" bgImage={serviceBg} />
      <main className="privacy-policy">
        <section>
          <h2>Privacy Policy</h2>
          <p>
            Customer Supports 24x7 collects customer details only to respond to
            service enquiries, schedule repairs, and provide booking support.
          </p>
          <p>
            We do not sell personal information. Details shared through forms or
            calls may be used by our team to contact you about your appliance
            repair request.
          </p>
          <p>
            For questions about your information, contact us using the details
            provided on the website.
          </p>
        </section>
      </main>
    </>
  );
};

export default PrivacyPolicy;
